import { PDF_PAGE_CHROME } from './pdfPageChrome';

export const PDF_TABLE_THEME = {
    bodyFontSize: 6.5,
    headerFontSize: 7,
    badgeFontSize: 6.5,
    titleFontSize: 14,
    metaFontSize: 8,
    sectionFontSize: 10,
    cellPadding: { top: 5, right: 4, bottom: 5, left: 4 },
    badgePadding: { top: 4, right: 4, bottom: 4, left: 4 },
    badgeMinHeight: 18,
    textColor: [45, 48, 71],
    mutedTextColor: [107, 111, 137],
    borderColor: [221, 222, 228],
    headerFill: [27, 33, 73],
    zebraFill: [248, 249, 252],
    pageMargin: PDF_PAGE_CHROME.marginX,
};

export const CSS_VAR_COLORS = {
    'var(--RAG-Green)': '#198754',
    'var(--RAG-Red)': '#b00020',
    'var(--RAG-Amber)': '#ffc107',
};

const hexToRgb = hex => {
    if (!hex || typeof hex !== 'string') return null;
    const normalized = hex.replace('#', '').trim();
    if (normalized.length === 3) {
        const [r, g, b] = normalized.split('');
        return [parseInt(`${r}${r}`, 16), parseInt(`${g}${g}`, 16), parseInt(`${b}${b}`, 16)];
    }
    if (normalized.length !== 6) return null;
    return [
        parseInt(normalized.slice(0, 2), 16),
        parseInt(normalized.slice(2, 4), 16),
        parseInt(normalized.slice(4, 6), 16),
    ];
};

export const resolvePdfColor = color => {
    if (!color) return null;
    if (color === 'white') return [255, 255, 255];
    const resolved = CSS_VAR_COLORS[color] || color;
    if (typeof resolved === 'string' && resolved.startsWith('#')) {
        return hexToRgb(resolved);
    }
    return null;
};

export const isWhiteFill = fillColor =>
    Array.isArray(fillColor) && fillColor[0] === 255 && fillColor[1] === 255 && fillColor[2] === 255;

export const applyPdfCellStyle = (data, cellStyle, columnKey, badgeColumns = new Set()) => {
    if (!cellStyle) return;

    if (cellStyle.fillColor) {
        data.cell.styles.fillColor = cellStyle.fillColor;
    }
    if (cellStyle.textColor) {
        data.cell.styles.textColor = cellStyle.textColor;
    }
    if (cellStyle.halign) {
        data.cell.styles.halign = cellStyle.halign;
    }
    if (cellStyle.valign) {
        data.cell.styles.valign = cellStyle.valign;
    }
    if (cellStyle.fontStyle) {
        data.cell.styles.fontStyle = cellStyle.fontStyle;
    }

    if (cellStyle.badge !== false && (cellStyle.badge || badgeColumns.has(columnKey))) {
        data.cell.styles.fontSize = PDF_TABLE_THEME.badgeFontSize;
        data.cell.styles.cellPadding = PDF_TABLE_THEME.badgePadding;
        data.cell.styles.minCellHeight = PDF_TABLE_THEME.badgeMinHeight;
    }

    if (cellStyle.bordered) {
        data.cell.styles.lineWidth = 0.5;
        data.cell.styles.lineColor = PDF_TABLE_THEME.borderColor;
    }
};

export const buildBadgeStyle = ({ bg, color, badge = true, halign = 'center' }) => {
    const fillColor = resolvePdfColor(bg) || [255, 255, 255];
    const textColor = resolvePdfColor(color) || PDF_TABLE_THEME.mutedTextColor;
    const isNeutral = isWhiteFill(fillColor);

    return {
        fillColor,
        textColor,
        halign,
        valign: 'middle',
        fontStyle: isNeutral ? 'normal' : 'bold',
        bordered: isNeutral,
        badge,
    };
};

export const defaultCellStyle = () => ({
    textColor: PDF_TABLE_THEME.textColor,
    halign: 'left',
    valign: 'middle',
    fontStyle: 'normal',
});
